<template>
  <v-app-bar class="item" height="56px" flat tile>
    <v-container class="d-flex justify-space-between align-center px-3 py-1">
      <v-btn class="ml-n3" color="transparent" to="/" depressed small fab>
        <v-icon size="20" color="secondary">fa-chevron-left</v-icon>
      </v-btn>

      <div
        class="
          grey--text
          text--darken-4 text-body-1 text-center
          font-weight-medium
          item-title
        "
      >
        <span>
          {{ title }}
        </span>
      </div>

      <slot name="right-button" />
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  background-color: var(--v-header-color) !important;

  &-title {
    left: 40px;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    right: 40px;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
      pointer-events: initial;
    }
  }
}

.item::v-deep {
  .v-toolbar__content {
    padding: 0 !important;
  }
}
</style>
